import axios from 'axios'

import { getApiUrl } from '#/shared/lib/constants'

export const getBalance = async (token: string): Promise<number> => {
	try {
		const { data } = await axios.get<{ current_token_balance: number }>(getApiUrl() + '/payments/user-balance', {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})

		return data.current_token_balance
	} catch (err) {
		return 0
	}
}
